<template>
  <div>
    <div class="not-print">
      <b-row>
        <b-col>
          <b-card title="Configurações de Etiquetas">
            <b-card-text>
              <b-row>
                <b-col>
                  <number-input
                    :decimalPlaces="0"
                    v-model="params.page.itens_per_page"
                    alias="Itens por pagina"
                  />
                </b-col>

                <b-col>
                  <number-input
                    :decimalPlaces="0"
                    v-model="params.page.margin"
                    alias="Margem da pagina (mm)"
                  />
                </b-col>
                <b-col>
                  <number-input
                    :decimalPlaces="0"
                    v-model="params.page.padding"
                    alias="Preenchimento da pagina  (mm)"
                  />
                </b-col>
                <b-col>
                  <number-input
                    :decimalPlaces="0"
                    v-model="params.page.height"
                    alias="Altura da pagina(mm)"
                  />
                </b-col>
                <b-col>
                  <number-input
                    :decimalPlaces="0"
                    v-model="params.page.width"
                    alias="Largura da pagina(mm)"
                  />
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <number-input
                    :decimalPlaces="0"
                    v-model="params.tag.description_font_size"
                    alias="Tamanho da descrição"
                  />
                </b-col>
                <b-col>
                  <number-input
                    :decimalPlaces="0"
                    v-model="params.tag.price_font_size"
                    alias="Tamanho do preço"
                  />
                </b-col>

                <b-col>
                  <number-input
                    :decimalPlaces="0"
                    v-model="params.tag.margin"
                    alias="Margem da etiqueta (mm)"
                  />
                </b-col>
                <b-col>
                  <number-input
                    :decimalPlaces="0"
                    v-model="params.tag.padding"
                    alias="Preenchimento da etiqueta (mm)"
                  />
                </b-col>
                <b-col>
                  <number-input
                    :decimalPlaces="0"
                    v-model="params.tag.height"
                    alias="Altura da etiqueta(mm)"
                  />
                </b-col>
                <b-col>
                  <number-input
                    :decimalPlaces="0"
                    v-model="params.tag.width"
                    alias="Largura da etiqueta(mm)"
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-checkbox
                    v-model="params.tag.show_barcode"
                    :value="true"
                    :unchecked-value="false"
                    switch
                  >
                    Exibir código de barras ?
                  </b-form-checkbox>
                </b-col>
                <b-col v-if="enabledPolicePrice" class="d-flex"
                  ><b-form-checkbox
                    v-model="params.tag.show_price_immediate"
                    :value="true"
                    :unchecked-value="false"
                    switch
                  >
                    Exibir preço a vista ?
                  </b-form-checkbox>

                  <b-form-checkbox
                    class="ml-4"
                    v-model="params.tag.show_price_on_terms"
                    :value="true"
                    :unchecked-value="false"
                    switch
                  >
                    Exibir preço a prazo ?
                  </b-form-checkbox>
                </b-col>

                <b-col class="d-flex align-center">
                  <b-button-group dense>
                    <b-btn
                      :variant="isAlignmentActive('start')"
                      @click="alignment = 'start'"
                    >
                      <i class="fas fa-align-left" />
                    </b-btn>
                    <b-btn
                      :variant="isAlignmentActive('center')"
                      @click="alignment = 'center'"
                    >
                      <i class="fas fa-align-center" />
                    </b-btn>
                    <b-btn
                      :variant="isAlignmentActive('end')"
                      @click="alignment = 'end'"
                    >
                      <i class="fas fa-align-right" />
                    </b-btn>
                  </b-button-group>
                  <b-button-group class="ml-2" dense>
                    <b-btn
                      :variant="isAlignmentOrientation('portrait')"
                      @click="orientation = 'portrait'"
                    >
                      <i class="fas fa-portrait" />
                    </b-btn>
                    <b-btn
                      :variant="isAlignmentOrientation('landscape')"
                      @click="orientation = 'landscape'"
                    >
                      <i class="far fa-image" />
                    </b-btn>
                  </b-button-group>

                  <b-btn
                    class="text-capitalize ml-auto"
                    @click="printTag()"
                    color="primary"
                    >Imprimir
                  </b-btn>
                </b-col>
              </b-row>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <div v-for="page in pages" id="printable" :key="`page${page}`">
      <div :style="pageStyle">
        <template v-for="product in params.page.itens_per_page">
          <ProductTag
            :key="`product${product}/${page}`"
            :tag="params.tag"
            v-if="getProduct(selectedProducts[getIndex(page, product)])"
            :product="getProduct(selectedProducts[getIndex(page, product)])"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ProductTag from "@/components/product/sections/ProductTag.vue";

export default {
  components: {
    ProductTag
  },

  data() {
    return {
      params: {
        page: {
          itens_per_page: 24,
          alignment: "center",
          orientation: "portrait",
          height: 297,
          width: 210,
          padding: 0,
          margin: 0
        },

        tag: {
          height: 30,
          width: 70,
          padding: 2,
          margin: 2,
          price_font_size: 7,
          description_font_size: 8,
          show_barcode: true,
          show_price_immediate: true,
          show_price_on_terms: true
        }
      }
    };
  },

  mounted() {
    this.$store.commit("pageHasLoaded");

    if (localStorage.getItem("PrintTagConfig")) {
      this.params = JSON.parse(localStorage.getItem("PrintTagConfig"));
    }
  },
  computed: {
    enabledPolicePrice() {
      if (this.$store.state.company.product_payment_policy == 2) {
        return true;
      }
    },

    selectedProducts() {
      return JSON.parse(this.$store.getters["productsPrintTag/getProducts"]);
    },

    productsCount() {
      if (this.selectedProducts) {
        return this.selectedProducts.length;
      }
      return 1;
    },

    pages() {
      return Math.ceil(this.productsCount / this.params.page.itens_per_page);
    },

    alignment: {
      get() {
        return this.params.page.alignment;
      },
      set(value) {
        this.params.page.alignment = value;
      }
    },

    orientation: {
      get() {
        return this.params.page.orientation;
      },
      set(value) {
        this.params.page.orientation = value;
      }
    },
    pageStyle() {
      return {
        display: "flex",
        "flex-wrap": "wrap",
        "align-items": "center",
        "flex-direction": this.orientation == "portrait" ? "column" : "row",
        size: this.orientation,
        margin: ` ${this.params.page.margin}mm`,
        padding: ` ${this.params.page.padding}mm`,
        height: ` ${this.params.page.height}mm`,
        width: ` ${this.params.page.width}mm`,
        // border: "1px solid rgba(0,0,0,.12)"/
      };
    }
  },

  watch: {
    params: {
      deep: true,
      handler(newValue, oldValue) {
        localStorage.setItem("PrintTagConfig", JSON.stringify(this.params));
      }
    }
  },

  methods: {
    isAlignmentActive(alignment) {
      return this.alignment == alignment ? "primary" : "outline-primary";
    },

    isAlignmentOrientation(orientation) {
      return this.orientation == orientation ? "primary" : "outline-primary";
    },

    getProduct(product) {
      return product != null || product != undefined ? product : "";
    },

    getIndex(page_settings, item) {
      return (page_settings - 1) * this.params.page.itens_per_page + item - 1;
    },

    hasItemOnIndex(page_settings, item) {
      return this.getIndex(page_settings, item) < this.selectedProducts.length;
    },

    printTag() {
      var styleEl = document.createElement("style");
      document.head.appendChild(styleEl);
      var styleSheet = styleEl.sheet;
      styleSheet.insertRule(
        `@page { size: ${this.orientation}; margin: ${this.params.page.margin}mm; padding: ${this.params.page.padding}mm; height: ${this.params.page.height}mm; width: ${this.params.page.width}mm; }`,
        0
      );
      window.print();
    }
  }
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
  background-color: #fafafa;
  color: rgb(0, 0, 0);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
}

* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

@media print {
  html,
  body {
    border: 1px solid white;
    height: 99%;
    page-break-after: avoid;
    page-break-before: avoid;
  }
  .not-print {
    display: none;
  }
}
</style>
